var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.loadingWrap, _vm.$style[_vm.fileType]]},[_c('div',{class:_vm.$style.loading})])}
var staticRenderFns = []

export { render, staticRenderFns }